// extracted by mini-css-extract-plugin
export var sliderRange = "_nx-2";
export var sliderRoot = "_nx-0";
export var sliderThumb = "_nx-3";
export var sliderTrack = "_nx-1";